module.exports = (__parcel__import__("3DhZB")).then(() => parcelRequire('ieIpp'));